<template>
    <m-assembly-table ref='pageForm'
                    thDrag
                    :formData='formData'
                    :columns='columns'
                    :data='tableData'
                    :tableButtons='tableButtons'
                    :loading='loading'
                    :currentPage='settings.currentPage'
                    :pageSize='settings.pageSize'
                    :total='settings.total'
                    :settings='settings'
                    @onSubmit='onSubmit'
                    @onPageSizeChange='onPageSizeChange'
                    @onCurrentPageChange='onPageChange'
                    @onSelectionChange='onSelectionChange'
    >
    </m-assembly-table>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table';
import moment from 'moment';
import { exportExcel } from '@/utils/tool';

export default {
    name: 'supplierEcConfirm',
    components: {
        mAssemblyTable,
    },
    data() {
        return {
            formData: {
                row: 3,
                items: [
                    {
                        title: this.$t('supplierEcConfirm.t1'), // 库存组织
                        value: '',
                        field: 'orgId',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                    },
                    {
                        value: '',
                        field: 'ntcode',
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('supplierEcConfirm.t2'), // MCO编码
                    },
                    {
                        value: '',
                        field: 'itemcode',
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('supplierEcConfirm.t3'), // 物料编码
                    },
                    {
                        title: this.$t('supplierEcConfirm.t4'), // 确认状态
                        value: 'UNCONFIRMED',
                        field: 'confirmFlag',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('supplierEcConfirm.t5'), // 已确认
                                    value: 'CONFIRMED ',
                                },
                                {
                                    label: this.$t('supplierEcConfirm.t6'), // 未确认
                                    value: 'UNCONFIRMED',
                                },
                            ],
                        },
                        type: 'select',
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('supplierEcConfirm.t1'), // 库存组织
                        key: 'invorgname',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t2'), // MCO编码
                        key: 'ntcode',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t7'), // MCO名称
                        key: 'ntname',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t3'), // 物料编码
                        key: 'itemcode',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t8'), // 物料描述
                        key: 'itemdesc',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t9'), // 图纸名称
                        key: 'drawname',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t10'), // 图纸描述
                        key: 'newdrawdescription',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t11'), // 变更原因
                        key: 'creason',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t12'), // MCO变更简介
                        key: 'ntcontentabstract',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t13'), // 是否影响成本
                        key: 'costeffect',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t14'), // 更改类型
                        key: 'ntreasontype',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t15'), // 备注
                        key: 'ntcontent',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t16'), // 发布时间
                        key: 'publishDate',
                        minWidth: 110,
                        render: (h, params) => {
                            const { publishDate } = params.row;
                            return h('span', publishDate ? moment(publishDate).format('YYYY-MM-DD') : '');
                        },
                    },
                    {
                        title: this.$t('supplierEcConfirm.t4'), // 确认状态
                        key: 'confirmFlag',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('supplierEcConfirm.t17'), // 确认日期
                        key: 'confirmDate',
                        minWidth: 110,
                        render: (h, params) => {
                            const { confirmDate } = params.row;
                            return h('span', confirmDate ? moment(confirmDate).format('YYYY-MM-DD') : '');
                        },
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('supplierEcConfirm.t18'), // 确认
                        type: 'primary',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        size: 'small',
                        click: (button) => {
                            button.loading = true;
                            this.confirmEcChange(button)
                                .finally(() => {
                                    button.loading = false;
                                });
                        },
                    },
                    {
                        label: this.$t('supplierEcConfirm.t19'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            button.loading = true;
                            exportExcel('/gscint/ecChangeInfo/exportEcChangeList', {
                                ...this.getFormDataVModel(this.formData.items),
                                vendorCode: this.vendorCode,
                            }, `${this.$t('route.supplierEcConfirm')}${moment().format('YYYYMMDDHHmmss')}.xlsx`, this, 'get')
                                .finally(() => {
                                    button.loading = false;
                                });
                            // this.$set(button, 'loading', true);
                            // let params = {
                            //     vendorCode: this.vendorCode,
                            //     ...this.getFormDataVModel(this.formData.items)
                            // };
                            // let paramsStr = '';
                            // for(let key in params){
                            //     paramsStr += key + '=' + params[key] + '&'
                            // }
                            // paramsStr = '?' + paramsStr.slice(0, -1);
                            // let url = `/gscapp/ecChangeInfo/exportEcChangeList${paramsStr}`;
                            // window.open(url);
                            // setTimeout(() => {
                            //     this.$set(button, 'loading', false);
                            // }, 5000);
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0,
                submitLoading: false,
            },
            selection: [],
        };
    },
    methods: {
        onSubmit(currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        onSearch() {
            this.loading = true;
            axios.post('/gscint/ecChangeInfo/queryEcChangeList', {
                ...this.getFormDataVModel(this.formData.items),
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                vendorCode: this.vendorCode,
            })
                .then((res) => {
                    const { list, total } = res.data.data;
                    if (list) {
                        this.selection = [];
                        this.tableData = list;
                        this.settings.total = total;
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        confirmEcChange() {
            const list = this.selection.map(({ invorgid: orgId, ntcode, itemcode }) => {
                return {
                    vendorCode: this.vendorCode,
                    orgId,
                    ntcode,
                    itemcode,
                };
            });
            return axios.post('/gscint/ecChangeInfo/confirmEcChange', list)
                .then((res) => {
                    const { code } = res.data.data;
                    if (code === '0') {
                        this.$Modal.success({
                            content: this.$t('supplierEcConfirm.t20'),
                        });
                        this.settings.currentPage = 1;
                        this.onSearch();
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
    },
    mounted() {
        this.getSRMInvLovListNew((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgId').options.values = data.map((item) => { 
                return {
                    value: item.erpOrgId,
                    label: item.organizationName,
                };
             });
        });
    },
};
</script>
